<template>
  <div  v-loading="loading">
    <div v-if="query4 != ''">
      <el-button type="warning" plain @click="yqbg()">重新生成该报告</el-button>
      <div>报告编号{{ resp_order }}</div>
      <div class="sad">
        行为逾期信息--<span class="zhuangtai">状态：{{ resp_code }}</span>
      </div>
      <div class="yuqi">
        <table border="1" class="biaoge">
          <tr>
            <th>探查结果编码:
              <span v-if="result_code == 1">逾期未还款</span>
              <span v-if="result_code == 2">正常履约</span>
              <span v-if="result_code == 3">逾期又还款</span>
              <span v-if="result_code == 4">无法确认</span>
            </th>
            <th>最大逾期金额:{{ max_overdue_amt }}</th>
            <th>最长逾期天数:{{ max_overdue_days }}</th>
            <th>最近逾期时间:{{ latest_overdue_time }}</th>
          </tr>
          <tr>
            <th>最大履约金额:{{ max_performance_amt }}</th>
            <th>最近履约时间:{{ latest_performance_time }}</th>
            <th>履约笔数:{{ count_performance }}</th>
            <th>当前逾期机构数:{{ currently_overdue }}</th>
          </tr>
          <tr>
            <th>当前履约机构数:{{ currently_performance }}</th>
            <th>异常还款机构数:{{ acc_exc }}</th>
            <th>睡眠机构数:{{ acc_sleep }}</th>
            <th></th>
          </tr>
        </table>
      </div>
    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">逾期报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="yqbg()">生成该报告</el-button>
      </div>
    </div>
  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from "../../product/product/part/spec/many/Table.vue";
export default {
  components: { Table },
  props: ["order_id", "query4"],
  data() {
    return {
      loading: false,
      resp_order: "",
      resp_code: "",
      result_code: "",
      max_overdue_amt: "",
      max_overdue_days: "",
      latest_overdue_time: "",
      max_performance_amt: "",
      latest_performance_time: "",
      count_performance: "",
      currently_overdue: "",
      currently_performance: "",
      acc_exc: "",
      acc_sleep: "",
    };
  },
  created() {
    // this.yqbg();
    // console.log("query4", JSON.parse(this.query4));
    if (this.query4 != '') {
      let yqbg = JSON.parse(this.query4);
      // console.log("逾期报告", yqbg);
      this.resp_order = yqbg.resp_order;
      this.resp_code = yqbg.resp_msg;
      this.result_code = yqbg.resp_data.result_code;
      //最大逾期金额
      this.max_overdue_amt = yqbg.resp_data.max_overdue_amt;
      //string	最长逾期天数
      this.max_overdue_days = yqbg.resp_data.max_overdue_days;
      //string	最近逾期时间
      this.latest_overdue_time = yqbg.resp_data.latest_overdue_time;
      //最大履约金额
      this.max_performance_amt = yqbg.resp_data.max_performance_amt;
      //最近履约时间
      this.latest_performance_time = yqbg.resp_data.latest_performance_time;
      //履约笔数
      this.count_performance = yqbg.resp_data.count_performance;
      //当前逾期机构数
      this.currently_overdue = yqbg.resp_data.currently_overdue;
      //当前履约机构数
      this.currently_performance = yqbg.resp_data.currently_performance;
      //异常还款机构数
      this.acc_exc = yqbg.resp_data.acc_exc;
      //睡眠机构数
      this.acc_sleep = yqbg.resp_data.acc_sleep;
    }
  },

  methods: {
    yqbg() {
      let self = this;
      self.loading = true;
      let Params = { orderid: self.order_id };
      FengkongApi.yuqi(Params, true)
        .then((data) => {
          // location.reload();
          self.query4 = 123;
          // console.log("逾期data", data.data.result);
          //报告编号
          self.resp_order = data.data.result.resp_data.resp_order;
          //状态
          self.resp_code = data.data.result.resp_msg;
          //探查结果编码
          self.result_code = data.data.result.resp_data.result_code;
          //最大逾期金额
          self.max_overdue_amt = data.data.result.resp_data.max_overdue_amt;
          //string	最长逾期天数
          self.max_overdue_days = data.data.result.resp_data.max_overdue_days;
          //string	最近逾期时间
          self.latest_overdue_time = data.data.result.resp_data.latest_overdue_time;
          //最大履约金额
          self.max_performance_amt = data.data.result.resp_data.max_performance_amt;
          //最近履约时间
          self.latest_performance_time = data.data.result.resp_data.latest_performance_time;
          //履约笔数
          self.count_performance = data.data.result.resp_data.count_performance;
          //当前逾期机构数
          self.currently_overdue = data.data.result.resp_data.currently_overdue;
          //当前履约机构数
          self.currently_performance = data.data.result.resp_data.currently_performance;
          //异常还款机构数
          self.acc_exc = data.data.result.resp_data.acc_exc;
          //睡眠机构数
          self.acc_sleep = data.data.result.resp_data.acc_sleep;
          self.loading = false;
          self.$message({
            message: '加载完成',
            type: 'success'
          });
        })
        .catch((error) => { });
    }
  },
};
</script>
  
<style>
.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.zhuangtai {
  color: #1890ff;
  font-size: 20px;
}

.sad {
  font-size: 20px;
  display: flex;
  justify-content: center;
}

.diyige {
  margin-top: 50px;
}

.yuqi {
  margin-top: 50px;

}</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail6.vue